import { Stack, Typography } from "@mui/material";
import { parseAsStringEnum, useQueryState } from "nuqs";
import { useTranslation } from "react-i18next";

import { GqlPlannerShiftCompletionStatus } from "~/__generated__";
import GaiaPageLayoutColumn from "~/modules/app/components/GaiaPageLayoutColumn";
import useCurrentUser from "~/modules/auth/hooks/useCurrentUser";
import FieldworkerShifts from "~/shared/components/FieldworkerShifts";
import PlannerShiftCompletionStatusSelect from "~/shared/components/PlannerShiftCompletionStatusSelect";

import useFieldworkerShiftsScreen_GetAll from "./api/useFieldworkerShiftsScreen_GetAll";

export default function FieldworkerShiftsScreen() {
    const { t } = useTranslation("fieldworker");
    const currentUser = useCurrentUser();

    const [plannerShiftCompletionStatusFilter, setPlannerShiftCompletionStatusFilter] = useQueryState(
        "plannerShiftCompletionStatus",
        parseAsStringEnum<GqlPlannerShiftCompletionStatus>(Object.values(GqlPlannerShiftCompletionStatus)),
    );

    const { data, loading } = useFieldworkerShiftsScreen_GetAll({
        userId: currentUser?.id,
        plannerShiftCompletionStatus: plannerShiftCompletionStatusFilter ?? undefined,
        sortBy: "startTime",
        sortOrder: "desc",
    });

    return (
        <GaiaPageLayoutColumn maxWidth="xl">
            <Stack rowGap={2} bgcolor={theme => theme.palette.background.paper} width="100%" p={2}>
                <Typography variant="h1">{t("shifts.title")}</Typography>
                <Stack rowGap={2}>
                    <PlannerShiftCompletionStatusSelect
                        value={plannerShiftCompletionStatusFilter ?? undefined}
                        onChange={newStatus => setPlannerShiftCompletionStatusFilter(newStatus ?? null)}
                    />
                    <FieldworkerShifts data={data} loading={loading} />
                </Stack>
            </Stack>
        </GaiaPageLayoutColumn>
    );
}
